import { buildPendingQuestionState } from '../reference/pendingQuestionTracker';
import { normalizeSignalText } from './turnSignalEligibility';

export function isAffirmativeConfirmation(value = '') {
  const lower = normalizeSignalText(value);
  return [
    'yes', 'yeah', 'yep', 'sure', 'please do', 'correct', 'correct it',
    'remember it', 'thats right', "that's right",
  ].includes(lower);
}

export function isNegativeConfirmation(value = '') {
  const lower = normalizeSignalText(value);
  return [
    'no', 'nope', 'nah', 'cancel', 'dont', "don't", 'do not',
    'leave it', 'never mind', 'nevermind',
  ].includes(lower);
}

export function buildPendingQuestionReply(pendingQuestionState, message) {
  const pending = pendingQuestionState?.pendingQuestion;
  const answerType = pending?.expectedAnswerType || 'general';
  const lower = String(message).toLowerCase().trim();
  const clarificationSignals = [
    'i mean', 'i meant', 'i just meant', 'no i mean', 'no i meant',
    'not one', 'more friends', 'other friends', 'i have more friends',
    'i have more', 'you only know', 'not thinking about one',
  ];
  if (clarificationSignals.some((phrase) => lower.includes(phrase))) {
    return "Got it — you mean you have more friends than the ones I know so far. If you want, you can tell me who they are and I’ll remember them too.";
  }
  const softNoWords = [
    'no', 'nope', 'nah', 'nevermind', 'never mind', 'its ok', "it's ok",
    'its okay', "it's okay", 'not really', 'just asking', 'just wondering',
  ];
  if (softNoWords.some((word) => lower === word)) {
    return "That's okay. I was just checking in. We can leave it there, or talk about something else.";
  }
  if (answerType === 'emotion') {
    return `Thanks for telling me. ${message} says a lot by itself. Want to stay with that a little more, or leave it there?`;
  }
  if (answerType === 'detail') return 'Got it. Thanks for clarifying. If you want, you can tell me a little more.';
  if (answerType === 'opinion') return 'That makes sense. Thanks for clarifying what you meant.';
  return 'Got it. Thanks for answering me.';
}

export function derivePendingQuestionFromAssistantReply({
  reply = '', frame = null, lastReferencedEntity = null,
  lastReferencedTopic = null, questionAuthority = 'optional',
}) {
  const derivedState = buildPendingQuestionState({
    inboundMessage: '', pendingQuestion: null, lastAssistantMessage: reply,
    frame, lastReferencedEntity, lastReferencedTopic,
    nextQuestionAuthority: questionAuthority,
  });
  return derivedState?.nextPendingQuestion || null;
}
